import React from "react";
import PropTypes from "prop-types";
import "./EvenementCard.scss";
import event1 from "assets/Event1.webp";
import BtnBlanc from "Components/Boutons/BtnBlanc/btn-blanc";
import { FaEllipsisH, FaUsers } from "react-icons/fa";
import { Menu } from "primereact/menu";
import { useRef } from "react";
import { connect } from "react-redux";
import parse from "html-react-parser";
import { formatDate, truncate } from "Services/functions";
import { updateUniversities } from "Redux/Actions/universitiesActions";
import { HTMLParseOptions } from "Services/htmlParseOptions";
import { useIntersectionObserver } from "Services/intersectionObserver";

const API_LINK = `${process.env.REACT_APP_BASE_URL_API}`.replace("/api", "");

const EvenementCard = (props) => {
  const [intersectionRef, isVisibleIntersection] = useIntersectionObserver();
  const menu = useRef(null);
  const items = [
    { label: "Modifier" },
    { separator: true },
    { label: "Supprimer" },
  ];

  const findLogo = () => {
    return (
      props.universities?.universitiesData?.find(
        (university) =>
          university.slug === props.eventDetails?.university?.slug ||
          university.slug === props.eventDetails?.universitySlug
      )?.imageTransparentAndColorUrl || ""
    );
  };

  const findUniversityName = () => {
    return (
      props.universities.universitiesData.find(
        (university) =>
          university.slug === props.eventDetails?.university?.slug ||
          university.slug === props.eventDetails?.universitySlug
      )?.name || ""
    );
  };

  const logo = findLogo();
  const universityName = findUniversityName();
  return (
    <div
      className="evenement_container cardHoverEvenement"
      onClick={() => {
        props.onClick && props.onClick();
      }}
      ref={intersectionRef}
    >
      <div className="evenement_container__top">
        <div className="evenement_container__top__categorie">
          <span className="etiquette"> {props.categorie.label} </span>
        </div>
        {isVisibleIntersection && (
          <div className="evenement_container__image">
            {props.url == "event1" ? (
              <>
                <img src={event1} alt="Fond événement" loading="lazy" />
                <div
                  className="image__bg"
                  style={{ backgroundImage: `url(${event1})` }}
                ></div>
              </>
            ) : (
              <>
                <img
                  src={ props.url}
                  alt="Fond événement"
                  onError={(e) => {
                    e.target.src = event1;
                  }}
                  loading="lazy"
                />
                <div
                  className="image__bg"
                  style={{
                    backgroundImage: `url(${
                      props.url})`,
                    }}

                ></div>
              </>
            )}
          </div>
        )}
      </div>
      <div className="evenement_container__corps">
        <div className="evenement_container__corps__debutdate">
          {props.debutDate}
          {props.groupe && (
            <>
              <Menu
                appendTo={document.getElementById("app")}
                model={items}
                popup
                ref={menu}
                style={{ textAlign: "center" }}
              />
              <div className="btn-point">
                <BtnBlanc
                  btnAction={() => (event) => menu.current.toggle(event)}
                >
                  <FaEllipsisH />
                </BtnBlanc>
              </div>
            </>
          )}
        </div>
        <div className="evenement_container__corps__findate">
          {props.finDate}
        </div>
        {props.groupe ? (
          <div className="event_groupe">
            <FaUsers /> {props.groupe_name}
          </div>
        ) : (
          <div className="evenement_container__corps__inscription">
            {props.inscription
              ? "Complet"
              : `Inscriptions ouvertes ${
                  props?.registerEnd != undefined
                    ? `jusqu'au ${formatDate(props.registerEnd)}`
                    : ""
                }`}
          </div>
        )}

        <div className="evenement_container__corps__title">
          {truncate(props.title, 26)}
        </div>
        <div className="evenement_container__corps__chapeau">
          <span>{parse(truncate(props?.chapeau, 80), HTMLParseOptions)}</span>
        </div>
      </div>
      <div className="evenement_container__bottom">
        <div className="evenement_container__bottom__lien">En savoir plus</div>
        <div className="evenement_container__bottom__logo">
          <img
            src={API_LINK + logo}
            alt={"Logo Université " + universityName}
            title={"Logo Université " + universityName}
            loading="lazy"
          />
        </div>
      </div>
    </div>
  );
};

EvenementCard.propTypes = {
  categorie: PropTypes.object,
  debutDate: PropTypes.string,
  finDate: PropTypes.string,
  title: PropTypes.string,
  inscription: PropTypes.bool,
  chapeau: PropTypes.any,
  logo: PropTypes.any,
  image: PropTypes.any,
  groupe: PropTypes.bool,
  groupe_name: PropTypes.string,
  url: PropTypes.string,
  onClick: PropTypes.func,
  eventDetails: PropTypes.object,
  universities: PropTypes.object,
  handleUpdateUniversities: PropTypes.func,
  registerEnd: PropTypes.string,
  nexusUrl: PropTypes.string,
};

const mapStateToProps = (state) => ({
  universities: state.universities,
});

const mapDispatchToProps = (dispatch) => ({
  handleUpdateUniversities: (value) => {
    dispatch(updateUniversities(value));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(EvenementCard);
